import api from "./axios";

const questionnaireApi = {
  getAll: () => api.get("/admin/questionnaires"),

  getDetail: (id) => api.get(`/admin/questionnaires/${id}`),

  addQuestion: (questionnaireId, data) =>
    api.post(`/admin/questionnaires/${questionnaireId}/questions`, data),

  updateQuestion: (questionId, data) =>
    api.put(`/admin/questions/${questionId}`, data),

  deleteQuestion: (questionId) => api.delete(`/admin/questions/${questionId}`),
};

export default questionnaireApi;
